import { render, staticRenderFns } from "./VerifyAlert.vue?vue&type=template&id=01ab1c80&"
import script from "./VerifyAlert.vue?vue&type=script&lang=js&"
export * from "./VerifyAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports